import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import pinnedItemsAPI from 'api/ApiActions/PinnedItems/Action'

const searchParams = new URLSearchParams(window.location.search)
const projectId = searchParams.get('project_id') as string
const toolType = searchParams.get('tool_type') as string

export const fetchPinnedItems: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('pinnedItems/fetchPinnedItems', async (_obj, { rejectWithValue }) => {
  try {
    const response = await pinnedItemsAPI.get(projectId)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const createPinnedItem: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('pinnedItems/createPinnedItem', async ({ name }, { rejectWithValue }) => {
  try {
    const response = await pinnedItemsAPI.post(projectId, name, toolType)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error)
  }
})
